import { render } from "./MTextArea.vue?vue&type=template&id=3afc1d3e&scoped=true"
import script from "./MTextArea.vue?vue&type=script&lang=ts"
export * from "./MTextArea.vue?vue&type=script&lang=ts"

import "./MTextArea.vue?vue&type=style&index=0&id=3afc1d3e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3afc1d3e"

export default script